import * as React from "react";

const GlassBoxExternalScript = () => {
    React.useEffect(() => {
        const GlassBoxScript = () => {
            const glassBoxScript = document.createElement("script");
            glassBoxScript.type = "text/javascript";
            glassBoxScript.id = "_cls_detector";
            glassBoxScript.src = "https://cdn.gbqofs.com/husky/p/detector-dom.min.js";
            glassBoxScript.setAttribute(
                "data-clsconfig",
                "reportURI=https://c2001.report.gbss.io/t7fqbp25/glassbox/reporting/f49e780b-c2ff-8832-a8e5-5023d5d6f8e2/cls_report",
            );
            document.head.appendChild(glassBoxScript);
        };
        GlassBoxScript();
    }, []);
    return null;
};

export default GlassBoxExternalScript;
